import {
  SET_LOCATIONS,
  SET_LOCATIONS_CACHE,
  SET_LOCATION_FILTERS,
  SET_FILTERS_VISIBILITY,
  SET_SELECTED_LOCATION,
  SET_INITIAL_LOCATION,
  SET_SELECTED_LOADING,
  SET_LOCATION_DETAILS_CACHE,
} from '../constants/types';

const initialState = {
  locations: [],
  locationsCache: [],
  selected: null,
  selectedLoading: false,
  locationDetailsCache: {},
  filters: [],
  filtersVisible: false,
  initialLocation: null,
};

const locationReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_LOCATIONS:
      return {
        ...state,
        locations: action.locations,
      };
    case SET_LOCATIONS_CACHE:
      return {
        ...state,
        locationsCache: action.cache,
      };
    case SET_LOCATION_FILTERS:
      return {
        ...state,
        filters: action.filters,
      };
    case SET_FILTERS_VISIBILITY:
      return {
        ...state,
        filtersVisible: action.visible,
      };
    case SET_SELECTED_LOCATION:
      return {
        ...state,
        selected: action.location,
      };
    case SET_INITIAL_LOCATION:
      return {
        ...state,
        initialLocation: action.location,
      };
    case SET_SELECTED_LOADING:
      return {
        ...state,
        selectedLoading: action.loading,
      };
    case SET_LOCATION_DETAILS_CACHE:
      return {
        ...state,
        locationDetailsCache: action.cache,
      };
    default:
      return state;
  }
};

export default locationReducer;
